<template>
    <div class="form-element__container form-element__container--location-arrow" :id="fullFormIdentifier + '-container'">
        <input
            :id="fullFormIdentifier"
            v-bind:value="value"
            v-on:input="$emit('input', $event.target.value)"
            class="form-element__input form-element__input--location-arrow"
            :class="{ 'form-element__input--active': isFilled }"
            type="text"
            :name="inputName"
            :data-validate="inputValidate ? 'input' : false"
            :data-nullable="validationNullable"
            :data-validate-message="validationMessage"
            :data-error-target="fullFormIdentifier + '-container'"
            :placeholder="inputTitle"
            data-location-element="true"
            data-location-list="true"
            data-customer-location="true"
            autocomplete="off"
            ref="input"
        />
        <img class="form-element__location-arrow" data-location-element="true" data-geolocation="true" src="/images/use-my-location.svg" />
    </div>
</template>

<script>
export default {
    props: {
        value: {
            default: null,
            required: false,
        },
        inputValidate: {
            type: Boolean,
            default: false,
        },
        inputNullable: {
            type: Boolean,
            default: true,
        },
        inputNullable: {
            type: Boolean,
            default: false,
        },
        inputName: {
            type: String,
            default: "location",
        },
        inputTitle: {
            type: String,
            required: false,
            default: "Postcode/City",
        },
        formIdentifier: {
            type: String,
            default: "form",
        },
    },
    data() {
        return {
            googleClass: false,
            autocomplete: false,
        };
    },
    computed: {
        isFilled() {
            if (this.value == null || this.value == "") {
                return false;
            }

            return true;
        },
        validationStar() {
            if (this.inputNullable) {
                return "";
            }
            return " *";
        },
        validationNullable() {
            if (this.inputNullable) {
                return 1;
            }
            return false;
        },
        validationMessage() {
            if (this.inputValidateMessage) {
                return this.inputValidateMessage;
            }
            return false;
        },
        fullFormIdentifier() {
            return this.formIdentifier + "-" + this._uid;
        },
    },
};
</script>

<style scoped>
@media (max-width: 767px) {
    .form-inline .location-lookup .form-control {
        display: inline-block;
        max-width: calc(100% - 42px);
    }
}
.pac-container {
    z-index: 20000;
}
</style>